import Vue from 'vue';

Vue.mixin( {
    methods: {
        __: function (string) {
            if ( typeof(window.translations) !== 'undefined' && typeof window.translations[ string ] !== 'undefined' ) {
                return window.translations[ string ];
            }

            return string;
        }
    }
} );



// WEBPACK FOOTER //
// ./resources/js/mixins/locale.js